export const nationalStructure = {
  "Organization Leadership": {
    description: "Provides overall direction, strategic partnerships, and national governance across all chapters.",
    roles: [
      { role: "Founder & Executive Director" },
      { role: "Deputy Director" },
      { role: "Chief Operating Officer" },
      { role: "Chief Financial Officer" },
      { role: "Chief Marketing Officer" },
      { role: "Director of Chapter Expansion" },
    ],
  },
  "Organization Programs Leadership": {
    description: "Oversees and scales national-level programs like Research Tracks, Training, and Internships.",
    roles: [
      { role: "National Programs Executive" },
      { role: "Director of Research" },
      { role: "Director of Training" },
      { role: "Director of Internships" },
    ],
  },
  "Chapter Coordination": {
    description: "Supports chapter formation, ensures alignment with national goals, and manages communication between chapters.",
    roles: [
      { role: "Regional Coordinator" },
      { role: "Chapter Liaison" },
      { role: "Chapter Support Analyst" },
    ],
  },
  "Organization Research Infrastructure": {
    description: "Supports national-level research collaboration, tool access, and cross-institution projects.",
    roles: [
      { role: "National Research Infrastructure Lead" },
      { role: "Platform & Tools Coordinator" },
      { role: "Research Data Manager" },
    ],
  },
  "External Engagement & Partnerships": {
    description: "Manages relationships with sponsors, industry partners, and academic institutions at the national level.",
    roles: [
      { role: "Director of Partnerships" },
      { role: "Corporate Relations Manager" },
      { role: "Academic Outreach Manager" },
    ],
  }
};
